import { FormControlLabel, Switch } from "@mui/material";
import SoftBox from "components/SoftBox";
import React, { useEffect, useState } from "react";
import { useAppServices } from "hook/services";
import { useAgencyInfo } from "context/agency";
import Select from "react-select";
import Loader from "examples/Loader";
import PrimaryButton from "../../../../components/PrimaryButton";

function Workflows({ data, workflows }) {
  const [agency, Update] = useAgencyInfo();
  const [loading, setLoading] = useState(true);

  const [sub_accounts_subscription_fail, setsub_accounts_subscription_fail] = useState(
    agency?.subscription_setting?.sub_accounts_subscription_fail || false
  );
  const [sub_accounts_admin_upgrade_subscription, setsub_accounts_admin_upgrade_subscription] =
    useState(agency?.subscription_setting?.sub_accounts_admin_upgrade_subscription || false);
  const [sub_accounts_admin_cancel_subscription, setsub_accounts_admin_cancel_subscription] =
    useState(agency?.subscription_setting?.sub_accounts_admin_cancel_subscription || false);

  const [toggleChecked, setToggleChecked] = useState(sub_accounts_subscription_fail);
  const [toggleChecked1, setToggleChecked1] = useState(sub_accounts_admin_upgrade_subscription);
  const [toggleChecked2, setToggleChecked2] = useState(sub_accounts_admin_cancel_subscription);

  const handleToggleChange = async (event) => {
    const checked = event.target.checked;
    setToggleChecked(checked);
    setsub_accounts_subscription_fail(checked);
    await toogle_data_save({ sub_accounts_subscription_fail: checked });
  };

  const handleToggleChange1 = async (event) => {
    const checked = event.target.checked;
    setToggleChecked1(checked);
    setsub_accounts_admin_upgrade_subscription(checked);
    await toogle_data_save({ sub_accounts_admin_upgrade_subscription: checked });
  };

  const handleToggleChange2 = async (event) => {
    const checked = event.target.checked;
    setToggleChecked2(checked);
    setsub_accounts_admin_cancel_subscription(checked);
    await toogle_data_save({ sub_accounts_admin_cancel_subscription: checked });
  };

  const toogle_data_save = async (updatedFields) => {
    const payload = {
      _id: agency._id,
      sub_accounts_subscription_fail,
      sub_accounts_admin_upgrade_subscription,
      sub_accounts_admin_cancel_subscription,
      ...updatedFields, // Merge the specific field to update
    };

    try {
      const { response } = await AppService.saas.subscription_setting({ payload });
      if (response) {
        console.log("Toggle data saved successfully!");
      }
    } catch (error) {
      console.error("Error saving toggle data:", error);
    }
  };

  const [formData, setFormData] = useState([]);
  const AppService = useAppServices();

  useEffect(() => {
    if (workflows.length && agency?.workflows) {
      setFormData({
        claim_request_approved: workflows?.find(
          (item) => item.value === agency?.workflows?.claim_request_approved
        ),
        claim_request_rejected: workflows?.find(
          (item) => item.value === agency?.workflows?.claim_request_rejected
        ),
        forgotten_password: workflows?.find(
          (item) => item.value === agency?.workflows?.forgotten_password
        ),
        listing_upgraded_to_premium: workflows?.find(
          (item) => item.value === agency?.workflows?.listing_upgraded_to_premium
        ),
        new_business_request: workflows?.find(
          (item) => item.value === agency?.workflows?.new_business_request
        ),
        new_business_request_approved: workflows?.find(
          (item) => item.value === agency?.workflows?.new_business_request_approved
        ),
        new_event_added: workflows?.find(
          (item) => item.value === agency?.workflows?.new_event_added
        ),
        new_listing_added: workflows?.find(
          (item) => item.value === agency?.workflows?.new_listing_added
        ),
        new_user_created: workflows?.find(
          (item) => item.value === agency?.workflows?.new_user_created
        ),
        reset_password: workflows?.find((item) => item.value === agency?.workflows?.reset_password),
        user_applied_for_job: workflows?.find(
          (item) => item.value === agency?.workflows?.user_applied_for_job
        ),
        new_blog_added: workflows?.find((item) => item.value === agency?.workflows?.new_blog_added),
        new_claim_request: workflows?.find(
          (item) => item.value === agency?.workflows?.new_claim_request
        ),
        news_feed_created: workflows?.find(
          (item) => item.value === agency?.workflows?.news_feed_created
        ),
      });
      setLoading(false);
    }
    if (!agency?.workflows) {
      setLoading(false);
    }
    if(!agency?.workflows){
      setLoading(false);
    }
  }, [agency, workflows]);

  const handleSelectChange = (selectedOption, name) => {
    setFormData({
      ...formData,
      [name]: selectedOption,
    });
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    const workflows = {
      claim_request_approved: e.target.claim_request_approved.value,
      claim_request_rejected: e.target.claim_request_rejected.value,
      forgotten_password: e.target.forgotten_password.value,
      listing_upgraded_to_premium: e.target.listing_upgraded_to_premium?.value,
      new_business_request: e.target.new_business_request?.value,
      new_business_request_approved: e.target.new_business_request_approved?.value,
      new_listing_added: e.target.new_listing_added?.value,
      new_event_added: e.target.new_event_added?.value,
      new_listing_added: e.target.new_listing_added?.value,
      new_user_created: e.target.new_user_created?.value,
      reset_password: e.target.reset_password?.value,
      user_applied_for_job: e.target.user_applied_for_job?.value,
      new_blog_added: e.target.new_blog_added?.value,
      new_claim_request: e.target.new_claim_request?.value,
      news_feed_created: e.target.news_feed_created?.value,
    };

    const payload = {
      workflows: { ...agency?.workflows, ...workflows },
      _id: agency._id,
    };
    console.log("workflowsworkflowsworkflowsworkflows", workflows);
    const { response } = await AppService.agency.update({
      payload,
      toaster: true,
    });
    if (response) {
      console.log(response.data);
    }
  };
  if (loading) {
    return (
      <div
        style={{
          height: "100vh",
          width: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          background: "rgba(255, 255, 255, 0.7)",
        }}
      >
        <Loader />
      </div>
    );
  }

  return (
    <SoftBox
      mx={0}
      py={0}
      px={0}
      variant="outlined"
      display="d-flex"
      justifyContent="space-between"
      alignItems="center"
    >
      <div style={{ width: "100%" }}>
        <div className="d-flex justify-content-between bg-white w-100">
          <div style={{ width: "100%" }}>
            <form onSubmit={handleSubmit}>
              <div style={{ marginBottom: "20px" }}>
                <p style={{ lineHeight: "10px" }}>Claim Request Approved :</p>
                <small>It will run when Claim Request Approved.</small>

                <Select
                  value={formData.claim_request_approved}
                  onChange={(option) => handleSelectChange(option, "claim_request_approved")}
                  options={workflows}
                  placeholder="Select option"
                  name="claim_request_approved"
                />
              </div>

              <div style={{ marginBottom: "20px" }}>
                <p style={{ lineHeight: "10px" }}>Claim Request Rejected :</p>
                <small>It will run when Claim Request Rejected.</small>

                <Select
                  value={formData.claim_request_rejected}
                  onChange={(option) => handleSelectChange(option, "claim_request_rejected")}
                  options={workflows}
                  placeholder="Select option"
                  name="claim_request_rejected"
                />
              </div>

              <div style={{ marginBottom: "20px" }}>
                <p style={{ lineHeight: "10px" }}>Forgotten Password :</p>
                <small>It will run when anyone Forgotten Password.</small>

                <Select
                  value={formData.forgotten_password}
                  onChange={(option) => handleSelectChange(option, "forgotten_password")}
                  options={workflows}
                  placeholder="Select option"
                  name="forgotten_password"
                />
              </div>

              <div style={{ marginBottom: "20px" }}>
                <p style={{ lineHeight: "10px" }}>Listing Upgraded To Premium :</p>
                <small>It will run when Listing Upgraded To Premium.</small>

                <Select
                  value={formData.listing_upgraded_to_premium}
                  onChange={(option) => handleSelectChange(option, "listing_upgraded_to_premium")}
                  options={workflows}
                  placeholder="Select option"
                  name="listing_upgraded_to_premium"
                />
              </div>

              <div style={{ marginBottom: "20px" }}>
                <p style={{ lineHeight: "10px" }}>New Business Request :</p>
                <small>It will run when New Business Request.</small>

                <Select
                  value={formData.new_business_request}
                  onChange={(option) => handleSelectChange(option, "new_business_request")}
                  options={workflows}
                  placeholder="Select option"
                  name="new_business_request"
                />
              </div>

              <div style={{ marginBottom: "20px" }}>
                <p style={{ lineHeight: "10px" }}>New Business Request Approved :</p>
                <small>It will run when a New Business Request is approved.</small>

                <Select
                  value={formData.new_business_request_approved}
                  onChange={(option) => handleSelectChange(option, "new_business_request_approved")}
                  options={workflows}
                  placeholder="Select option"
                  name="new_business_request_approved"
                />
              </div>

              <div style={{ marginBottom: "20px" }}>
                <p style={{ lineHeight: "10px" }}>New Event Added :</p>
                <small>It will run when New Event Added.</small>

                <Select
                  value={formData.new_event_added}
                  onChange={(option) => handleSelectChange(option, "new_event_added")}
                  options={workflows}
                  placeholder="Select option"
                  name="new_event_added"
                />
              </div>

              <div style={{ marginBottom: "20px" }}>
                <p style={{ lineHeight: "10px" }}>New Listing Added :</p>
                <small>It will run when New Listing Added.</small>

                <Select
                  value={formData.new_listing_added}
                  onChange={(option) => handleSelectChange(option, "new_listing_added")}
                  options={workflows}
                  placeholder="Select option"
                  name="new_listing_added"
                />
              </div>

              <div style={{ marginBottom: "20px" }}>
                <p style={{ lineHeight: "10px" }}>New User Created :</p>
                <small>It will run when New User Created.</small>

                <Select
                  value={formData.new_user_created}
                  onChange={(option) => handleSelectChange(option, "new_user_created")}
                  options={workflows}
                  placeholder="Select option"
                  name="new_user_created"
                />
              </div>

              <div style={{ marginBottom: "20px" }}>
                <p style={{ lineHeight: "10px" }}>Reset Password :</p>
                <small>It will run when anyone Reset Password.</small>

                <Select
                  value={formData.reset_password}
                  onChange={(option) => handleSelectChange(option, "reset_password")}
                  options={workflows}
                  placeholder="Select option"
                  name="reset_password"
                />
              </div>

              <div style={{ marginBottom: "20px" }}>
                <p style={{ lineHeight: "10px" }}>User Applied for Job :</p>
                <small>It will run when User Applied for Job.</small>

                <Select
                  value={formData.user_applied_for_job}
                  onChange={(option) => handleSelectChange(option, "user_applied_for_job")}
                  options={workflows}
                  placeholder="Select option"
                  name="user_applied_for_job"
                />
              </div>
              <div style={{ marginBottom: "20px" }}>
                <p style={{ lineHeight: "10px" }}>New Blog Added :</p>
                <small>It will run when new blog added.</small>

                <Select
                  value={formData.new_blog_added}
                  onChange={(option) => handleSelectChange(option, "new_blog_added")}
                  options={workflows}
                  placeholder="Select option"
                  name="new_blog_added"
                />
              </div>
              <div style={{ marginBottom: "20px" }}>
                <p style={{ lineHeight: "10px" }}>New Claim Request :</p>
                <small>It will run when new claim request.</small>

                <Select
                  value={formData.new_claim_request}
                  onChange={(option) => handleSelectChange(option, "new_claim_request")}
                  options={workflows}
                  placeholder="Select option"
                  name="new_claim_request"
                  menuPortalTarget={document.body}
                  styles={{
                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                  }}
                />
              </div>
              <div style={{ marginBottom: "20px" }}>
                <p style={{ lineHeight: "10px" }}>News Feed Created :</p>
                <small>It will run when news feed created.</small>

                <Select
                  value={formData.news_feed_created}
                  onChange={(option) => handleSelectChange(option, "news_feed_created")}
                  options={workflows}
                  placeholder="Select option"
                  name="news_feed_created"
                  menuPortalTarget={document.body}
                  styles={{
                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                  }}
                />
              </div>

              <div style={{ display: "flex", justifyContent: "flex-end", marginTop: 16 }}>
                <PrimaryButton type="submit">Save</PrimaryButton>
              </div>
            </form>
          </div>
        </div>
      </div>
    </SoftBox>
  );
}

export default Workflows;
